import { commerceOfferProperties } from "@/lib/analytics-ga4";
import { trackEvent } from "@/lib/analytics";

export function trackPostPurchaseAgentFollowupShown(props: {
  plan_id: string;
  order_id: string;
  source?: string;
  placement?: string;
  intent?: string;
  source_path?: string;
  customer_problem?: string;
}) {
  trackEvent("post_purchase_agent_followup_shown", props);
}

export function trackPostPurchaseAgentFollowupClicked(props: {
  plan_id: string;
  order_id: string;
  source?: string;
  placement?: string;
  intent?: string;
  source_path?: string;
  customer_problem?: string;
}) {
  trackEvent("post_purchase_agent_followup_clicked", props);
}

export function trackReportRemedyKitUpsellShown(props: {
  plan_id: string;
  order_id: string;
  source?: string;
  placement?: string;
  intent?: string;
  source_path?: string;
  customer_problem?: string;
  product_skus: string[];
  product_count: number;
}) {
  trackEvent("report_remedy_kit_upsell_shown", props);
  trackEvent(
    "commerce_offer_shown",
    commerceOfferProperties({
      ...props,
      offer_type: props.product_count > 1 ? "product_cart" : "product",
      checkout_channel: "shopify_product",
      commerce_system: "shopify",
    })
  );
}

export function trackReportRemedyKitUpsellClicked(props: {
  plan_id: string;
  order_id: string;
  source?: string;
  placement?: string;
  intent?: string;
  source_path?: string;
  customer_problem?: string;
  product_skus: string[];
  product_count: number;
}) {
  trackEvent("report_remedy_kit_upsell_clicked", props);
  trackEvent(
    "commerce_offer_clicked",
    commerceOfferProperties({
      ...props,
      offer_type: props.product_count > 1 ? "product_cart" : "product",
      checkout_channel: "shopify_product",
      commerce_system: "shopify",
    })
  );
}
